import { Controller } from "@hotwired/stimulus"

// The open editor of one contact card: the reason/fan-out fields only mean something for an inactive
// value, and an inactive value can't be preferred for anything. The server enforces the same rules —
// this only keeps the form from showing a state it won't save.
export default class extends Controller {
  static targets = ["status", "inactiveDetails", "purpose"]

  statusChanged() {
    const active = this.activeChecked

    if (this.hasInactiveDetailsTarget) {
      this.inactiveDetailsTarget.classList.toggle("hidden", active)
    }

    // Disabled rather than cleared: a disabled checkbox isn't submitted, and an inactive value has
    // its purposes dropped server-side anyway — while clearing them here would mean a stray tick of
    // Inactive and back saved the card with no purposes, silently dropping an outreach preference.
    this.purposeTargets.forEach((purpose) => { purpose.disabled = !active })
  }

  get activeChecked() {
    const checked = this.statusTargets.find((status) => status.checked)
    return checked ? checked.value === "1" : true
  }
}
